import { toRem } from 'helpers/theme'

/* eslint-disable quote-props */
const style = ({ theme, image }) => ({
    div: {
        maxWidth: toRem(100),
        marginRight: toRem(10),
        fontSize: toRem(12),
        [theme.breakpoints.up('md')]: {
            marginRight: toRem(75),
            fontSize: toRem(16)
        },
        '& .Number': {
            display: 'block',
            fontSize: toRem(20),
            lineHeight: 1.2,
            color: theme.colors.goldDark,
            [theme.breakpoints.up('md')]: {
                fontSize: toRem(40)
            }
        }
    }
})

export default style
